export const MuiChipNode = {
  styleOverrides: {
    root: {
      color: "white",
    },
  },
};
